import { Injectable } from '@angular/core';

export type StrumSet = {
  name: string,
  repeatStructure: number,
  structure: string // 'd'own | 'u'p | '_' Silent [] + uppercase for accent
}
@Injectable({
  providedIn: 'root'
})
export class StrummingService {
  // repeatStructure x stucture.length ===> 4 beats time
  public all: StrumSet[] = [
    { name: 'sotr style',
      repeatStructure: 1,
      structure: 'd_Du_uDu'
    },
    { name: 'jp_style',
      repeatStructure: 1,
      structure: 'd___D___d__ud__u'
    },
    { name: 'binary',
      repeatStructure: 4,
      structure: 'D_du'
    },
    { name: 'takeme',
      repeatStructure: 1,
      structure: 'D_DU_uDu'
    }
  ];
  private random5Pct = .95 + Math.random() * .1;
  constructor() { }
  stringHumanizer(bpm: number, rate: number): number { // time between strings of the same chord
    const timeReference = 60000 / (bpm * 20); 
    return rate * timeReference * this.random5Pct / 100;
  }
  get(pattern?: string): StrumSet {
    return pattern ? this.all.filter((strum => strum.name === pattern || strum.structure === pattern))[0] : this.all[0];
  }
}

